<template>
  <v-container fluid>
    <data-table
      :filters="filters"
      :limit="10"
      url="users"
      fields="email,first_name,last_name,last_activity,role.display_name,status,nexus_email,created_at"
      content="usersList"
      searchFields="first_name,last_name,email"
      class="mb-5">
      <template slot="title">
        <v-layout row wrap>
          <v-flex md9>
            <p class="headline mt-3">
              Usuarios
            </p>
          </v-flex>
          <v-flex md3 class="text-xs-right">
            <v-btn class="k-orange-linear white--text mt-2 mr-0" large @click="dialog = !dialog">
              CREAR USUARIO
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template slot="navigation-bar">
        <v-flex lg4>
          <v-text-field
            v-model="filters.search"
            label="Buscar..."
            color="black"
            solo>
          </v-text-field>
        </v-flex>
        <v-flex lg2 pl-2>
          <v-select
            v-model="filters.status"
            :items="statuses"
            color="grey"
            solo>
          </v-select>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-menu
            ref="from"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters['min-created_at']"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
            <v-text-field
              slot="activator"
              :value="formatDate(filters['min-created_at'], 'YYYY-MM-DD', 'DD/MM/YYYY')"
              class="k-orange-linear-text"
              prepend-icon="event"
              label="Desde"
              readonly
              solo>
            </v-text-field>
            <v-date-picker
              v-model="filters['min-created_at']"
              @input="$refs.from.save(filters['min-created_at'])"
              locale="es"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-menu
            ref="to"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters['max-created_at']"
            transition="scale-transition"
            min-width="290px"
            full-width
            offset-y
            lazy>
            <v-text-field
              slot="activator"
              :value="formatDate(filters['max-created_at'], 'YYYY-MM-DD', 'DD/MM/YYYY')"
              class="k-orange-linear-text"
              prepend-icon="event"
              label="Hasta"
              readonly
              solo>
            </v-text-field>
            <v-date-picker
              v-model="filters['max-created_at']"
              @input="$refs.to.save(filters['max-created_at'])"
              locale="es"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
      </template>
    </data-table>
    <save-dialog
      :title="title"
      :dialog="dialog"
      :form="form"
      :route="route"
      :edit="edit"
      :hasMore="false"
      :more="false">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="form.email"
              v-validate="'required|email|max:191'"
              data-vv-name="email"
              data-vv-as="email"
              :error-messages="errors.collect('email')"
              label="Email"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 pr-5>
            <v-text-field
              v-model="form.first_name"
              v-validate="'required|max:191'"
              data-vv-name="first_name"
              data-vv-as="primer nombre"
              :error-messages="errors.collect('first_name')"
              label="Nombre"
              color="black">
            </v-text-field>
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="form.last_name"
              v-validate="'required|max:191'"
              data-vv-name="last_name"
              data-vv-as="primer nombre"
              :error-messages="errors.collect('last_name')"
              label="Apellido"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 pr-5>
            <v-select
              v-model="form.role_id"
              v-validate="'required|numeric'"
              data-vv-name="role_id"
              data-vv-as="rol"
              :error-messages="errors.collect('role_id')"
              :items="roles"
              item-text="display_name"
              item-value="id"
              label="Rol"
              color="black"
              autocomplete>
            </v-select>
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="form.password"
              v-validate="`${edit ? '' : 'required|'}min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars`"
              data-vv-name="password"
              data-vv-as="contraseña"
              :error-messages="errors.collect('password')"
              label="Contraseña"
              color="black"
              hint="Esta contraseña deberá ser cambiada durante del primer inicio de sesión"
              type="password">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 pr-5>
            <v-select
              v-model="form.agent_id"
              data-vv-name="agent_id"
              :data-vv-as="$auth.user().company_id === 2 ? 'Asesor' : 'Agente'"
              :error-messages="errors.collect('agent_id')"
              :items="agents"
              item-value="id"
              item-text="name"
              :label="`Relacionar con ${$auth.user().company_id === 2 ? 'Asesor' : 'Agente'}`"
              color="black"
              autocomplete>
            </v-select>
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="form.nexus_email"
              v-validate="'required|max:191'"
              data-vv-name="nexus_email"
              data-vv-as="Correo de nexus"
              :error-messages="errors.collect('nexus_email')"
              label="Correo de nexus"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <permissions-v2 :permissions="permissions"></permissions-v2>
    <delete-dialog
      :text="deleteOptions.text"
      :id="deleteOptions.id"
      url="users"
      :dialog="deleteOptions.dialog"
      :delete-bus="deleteBus">
    </delete-dialog>
    <v-dialog v-model="changeUserPassword" persistent max-width="600px">
      <v-card>
        <v-toolbar color="k-orange-linear" class="white--text">
          <v-toolbar-title>Cambiar la contraseña de {{user.first_name}} {{user.last_name}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4 px-5">
          <v-form>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  color="black"
                  label="Contraseña"
                  v-model="user.password"
                  type="password"
                  :error-messages="errors.collect('password')"
                  v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                  data-vv-name="password"
                  data-vv-as="contraseña"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="user.confirm_password"
                  type="password"
                  :error-messages="errors.collect('confirm_password')"
                  v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                  data-vv-name="confirm_password"
                  data-vv-as="confirmación de contraseña"
                  label="Confirme la contraseña"
                  color="black">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="changeUserPassword = false">Cancelar</v-btn>
          <v-btn class="k-orange-linear-text" flat @click="updatePassword(user.id)">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import EventBus from '@/event-bus';
import DataTable from '@/components/global/DataTable';
import SaveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import UsersList from '@/components/user/UsersList';
import DeleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import PermissionsV2 from '@/components/user/PermissionsV2';
import formatDateMixin from '@/mixins/formatDate';

Vue.component('UsersList', UsersList);

export default {
  components: {
    DataTable,
    SaveDialog,
    DeleteDialog,
    PermissionsV2,
  },
  mixins: [
    saveDialogMixin,
    deleteDialogMixin,
    formatDateMixin,
  ],
  created() {
    this.axios.get('permissions').then(({ data }) => {
      this.permissions = data || [];
    }),
    this.axios.get('filters/agencies').then(({ data }) => {
      this.agencies = data;
    }).catch(() => {});
    this.getRoles();
    EventBus.$on('changePassword', (user) => {
      this.clearUserForm();
      this.user.id = user.id;
      this.user.first_name = user.first_name;
      this.user.last_name = user.last_name;
      this.changeUserPassword = true;
    });
  },
  destroyed() {
    EventBus.$off('changePassword');
  },
  data() {
    return {
      filters: {
        search: '',
        status: '',
        'min-created_at': '',
        'max-created_at': '',
        sort: '-created_at',
      },
      changeUserPassword: false,
      user: {
        name: '',
        password: '',
      },
      agencies: [],
      statuses: [
        {
          value: '',
          text: 'Estados',
        },
        {
          value: 'activo',
          text: 'Activo',
        },
        {
           value: 'bloqueado',
           text: 'Bloqueado',
         },
        {
          value: 'inactivo',
          text: 'Inactivo',
        },
        {
          value: 'pendiente',
          text: 'Pendiente',
        },
      ],
      form: {
        email: '',
        first_name: '',
        last_name: '',
        role_id: '',
        nexus_email: '',
        password: '',
        agent_id: null,
      },
      roles: [],
      route: 'users',
      showName: 'usuario',
      fields: 'email,first_name,last_name,role_id,agent_id, nexus_email',
      permissions: [],
    };
  },
  computed: {
    ...mapGetters({
      agents: 'agents',
    }),
  },
  methods: {
    clearUserForm() {
      Object.keys(this.user).forEach((key) => {
        if (Array.isArray(this.user[key])) {
          this.user[key] = [];
        } else {
          this.user[key] = '';
        }
      });
      this.$nextTick(() => {
        this.$validator.reset();
        this.errors.clear();
      });
    },
    updatePassword(id) {
      this.axios.patch(`/users/${id}`, {
        password: this.user.password,
        confirm_password: this.user.confirm_password,
      }).then(() => {
        this.changeUserPassword = false;
        this.clearUserForm();
      }).catch(() => { });
    },
    getRoles() {
      this.axios.get('roles').then(({ data }) => {
        this.roles = data;
      });
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.errors.clear();
      },
    },
    'form.password': {
      handler() {
        this.form.confirm_password = this.form.password;
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/user/Index.vue